import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  constructor(private http: HttpClient) { }

  // Single lead-capture entry point. Posts to this site's OWN server at a
  // same-origin relative path, so every environment (dev/staging/prod) hits its
  // own /Contact — which verifies reCAPTCHA + honeypot + rate-limit and forwards
  // to the CRM (Zoho) using a server-side token. The client never talks to the
  // CRM directly or handles tokens. Pass { contact: {...}, recaptchaToken, honeypot? }.
  // NOTE: forms submit from the browser, so the relative URL resolves to the
  // current origin. (Use `npm run dev:ssr` for local testing — bare `ng serve`
  // has no /Contact endpoint.)
  submitLead(data: any): Observable<any> {
    return this.http.post<any>('/Contact', data);
  }
}
